export default __webpack_public_path__ + "static/media/reviewer1.b66e7d84.png";